

























import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "Contact"
})
export default class Contact extends Vue {}
